import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

/**
 * Inline CTA at the end of each blog article. Links to landing final-cta
 * anchor. Copy aligned with the "punt de partida + test inicial" pivot —
 * no promises of a full program.
 */
export default function ArticleCTA({ langPrefix = "" }) {
  const { lang } = useLanguage();
  const ctaHref = `${langPrefix || "/"}#final-cta`;

  const eyebrow = lang === "es" ? "Un paso más honesto" : "Un pas més honest";
  const title = lang === "es"
    ? "¿Quieres entender mejor tu punto de partida?"
    : "Vols entendre millor el teu punt de partida?";
  const body = lang === "es"
    ? "Estamos en fase de validación. Déjanos tu correo y te enviaremos un test inicial para entender qué te puede estar bloqueando antes de empezar. Sin diagnósticos, sin presión y sin compromiso."
    : "Estem en fase de validació. Deixa'ns el teu correu i t'enviarem un test inicial per entendre què et pot estar bloquejant abans de començar. Sense diagnòstics, sense pressió i sense compromís.";
  const button = lang === "es" ? "Recibir el test inicial" : "Rebre el test inicial";

  return (
    <aside
      data-testid="article-cta"
      className="mt-14 border border-[#0B2545]/15 bg-[#0B2545] text-[#F9F8F6] rounded-2xl p-8 sm:p-10 relative overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-16 -right-16 h-64 w-64 rounded-full bg-[#B4C5A4]/15 blur-3xl" />
      <div className="relative">
        <p className="text-[10px] uppercase tracking-[0.24em] text-[#B4C5A4] font-sans-display font-semibold mb-3">
          {eyebrow}
        </p>
        <h3 className="font-sans-display text-2xl sm:text-3xl tracking-tight leading-tight mb-4 max-w-xl">
          {title}
        </h3>
        <p className="text-[#F9F8F6]/80 leading-relaxed mb-7 max-w-2xl">
          {body}
        </p>
        <Link
          to={ctaHref}
          data-testid="article-cta-button"
          className="lift-btn inline-flex items-center gap-2 h-12 px-6 bg-[#B4C5A4] text-[#0B2545] font-sans-display font-medium tracking-wide rounded-md hover:bg-[#a3b793] transition"
        >
          {button}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </aside>
  );
}
